import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const permissionGuard: CanActivateFn = (route, state) => {
  const data = sessionStorage.getItem('appData');
  const router = inject(Router);
  if (data) {
    return router.navigate(['errorpage/null']);
  }
  return true;
};
